import { render } from "./CardShowVip.vue?vue&type=template&id=772877de&scoped=true"
import script from "./CardShowVip.vue?vue&type=script&lang=js"
export * from "./CardShowVip.vue?vue&type=script&lang=js"

import "./CardShowVip.vue?vue&type=style&index=0&id=772877de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772877de"]])

export default __exports__